( function ( _s ) {
	_s.fn.ctaCards = function () {
		return this.each( el => {
			const _self = _s( el );
			const _cards = _self.find( '.col' );

			_cards.on( 'mouseover mouseleave', e => {
				_s( e.currentTarget )
					.find( '.cta-button.tertiary' )
					.toggleClass( 'is--hover', e.type === 'mouseover' );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.cta-cards-container' ).ctaCards();
	} );
} )( window._s );
